var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { logBadgeHistoryActionFunctionDef, printAccountBadgeFunctionDef, } from '../../../../backend/features/badges/shared';
import { useDownloadAccountBadgeAttachments } from '../../../../ui/features/badge-management/hooks/useDownloadAccountBadgeAttachments';
import { useAccountBadgeStorage } from '../../../../ui/features/form/hooks/useAccountBadgeStorage';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { showConfirmDialog, showErrorDialog, showProgressDialog } from '@juvare/common-web-ui/DialogHelper';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
export function useAccountBadgePrintAction() {
    const { t } = useBadgingTranslation();
    const { downloadAccountBadgeAttachment } = useDownloadAccountBadgeAttachments();
    const printAccountBadge = useTypedPlatformFunction(printAccountBadgeFunctionDef);
    const logBadgeHistoryAction = useTypedPlatformFunction(logBadgeHistoryActionFunctionDef);
    const accountBadgeStorage = useAccountBadgeStorage();
    const fetchAccountBadgeByPrintRequestParams = (_a) => __awaiter(this, [_a], void 0, function* ({ requestId, accountBadgeId }) {
        return yield accountBadgeStorage.listColumns({
            filter: [
                {
                    column: 'printRequestId',
                    value: requestId,
                    op: '=',
                },
                {
                    column: 'printStatus',
                    value: ['failed', 'success'],
                    op: 'in',
                },
                {
                    id: accountBadgeId,
                    op: '=',
                },
            ],
        }, 'printStatus', 'printRequestId', 'accountDisplayName');
    });
    const pollUntilPrintAccountBadgeRequestFinished = (params) => __awaiter(this, void 0, void 0, function* () {
        let response = yield fetchAccountBadgeByPrintRequestParams(params);
        while (!response.total) {
            yield new Promise((resolve) => {
                setTimeout(resolve, 1000);
            });
            response = yield fetchAccountBadgeByPrintRequestParams(params);
        }
        return response;
    });
    return (accountBadge) => __awaiter(this, void 0, void 0, function* () {
        const accountBadgeId = accountBadge.id;
        const badgeId = accountBadge.columns.badgeId;
        // [INFO]: printing in local environment is not supported.
        if (window.location.hostname === 'localhost' && !accountBadge.columns.isMigrated) {
            return showErrorDialog({
                title: t('badges.print.pdfGenerationNotSupportedLocalhost'),
            });
        }
        return yield new Promise((resolve) => {
            showProgressDialog({
                title: t('badges.print.generatingPdfReport'),
                callback: (done) => {
                    const handleCloseDialog = () => {
                        done();
                        resolve();
                    };
                    printAccountBadge({ accountBadgeId })
                        .then((_a) => __awaiter(this, [_a], void 0, function* ({ requestId }) {
                        try {
                            const { rows } = yield pollUntilPrintAccountBadgeRequestFinished({
                                requestId,
                                accountBadgeId,
                            });
                            const accountBadge = rows[0];
                            handleCloseDialog();
                            if (accountBadge.columns.printStatus === 'failed') {
                                handleErrorSnackbar(t('badges.print.failedToGeneratePdfError'));
                            }
                            if (accountBadge.columns.printStatus === 'success') {
                                showConfirmDialog({
                                    title: t('badges.print.confirmDownloadPdfReport'),
                                    confirmLabel: t('common.download'),
                                    onConfirm: () => {
                                        downloadAccountBadgeAttachment({
                                            accountBadgeId: accountBadge.id,
                                            accountDisplayName: accountBadge.columns.accountDisplayName,
                                        }).catch(handleErrorSnackbar);
                                    },
                                });
                                logBadgeHistoryAction({
                                    accountBadgeIds: [accountBadgeId],
                                    badgeId: badgeId,
                                    action: 'accountBadgePrinted',
                                }).catch(handleErrorSnackbar);
                            }
                        }
                        catch (error) {
                            handleCloseDialog();
                            handleErrorSnackbar(error);
                        }
                    }))
                        .catch((error) => {
                        handleCloseDialog();
                        handleErrorSnackbar(error);
                    });
                },
            });
        });
    });
}
